/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FxIdDomainStoreEnumsSupportedWebPublishingPlatformFromJSON, FxIdDomainStoreEnumsSupportedWebPublishingPlatformToJSON, } from './FxIdDomainStoreEnumsSupportedWebPublishingPlatform';
/**
 * Check if a given object implements the FxIdWebFeaturesGamesChooseGameRequest interface.
 */
export function instanceOfFxIdWebFeaturesGamesChooseGameRequest(value) {
    if (!('OriginUrl' in value) || value['OriginUrl'] === undefined)
        return false;
    if (!('WebPublishingPlatform' in value) || value['WebPublishingPlatform'] === undefined)
        return false;
    return true;
}
export function FxIdWebFeaturesGamesChooseGameRequestFromJSON(json) {
    return FxIdWebFeaturesGamesChooseGameRequestFromJSONTyped(json, false);
}
export function FxIdWebFeaturesGamesChooseGameRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'GameSystemName': json['GameSystemName'] == null ? undefined : json['GameSystemName'],
        'OriginUrl': json['OriginUrl'],
        'WebPublishingPlatform': FxIdDomainStoreEnumsSupportedWebPublishingPlatformFromJSON(json['WebPublishingPlatform']),
    };
}
export function FxIdWebFeaturesGamesChooseGameRequestToJSON(json) {
    return FxIdWebFeaturesGamesChooseGameRequestToJSONTyped(json, false);
}
export function FxIdWebFeaturesGamesChooseGameRequestToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'GameSystemName': value['GameSystemName'],
        'OriginUrl': value['OriginUrl'],
        'WebPublishingPlatform': FxIdDomainStoreEnumsSupportedWebPublishingPlatformToJSON(value['WebPublishingPlatform']),
    };
}
//# sourceMappingURL=FxIdWebFeaturesGamesChooseGameRequest.js.map